import styles from "./styles/ContainerWrapper.module.scss";
import { mobile, tablet, parseStyle, decodeStyle } from "../../../../juntion";
// import {
//     decodeStyle,
//     parseStyle,
// } from "../../../../../parser/parserResponsive";
import log from "cslog";
import classNames from "classnames";
import { useAction } from "../../../../hooks";

function ContainerWrapper({ label, children, index, data, dydb, gs, device }) {
    const { performAction } = useAction();
    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const decoded_styles = decodeStyle(ps.style, gs);

    return (
        <div
            // className={`${styles.wrapper} ${input.hoverAnimation}`}
            onClick={() =>
                performAction({
                    ...input.action,
                    dydb: dydb,
                })
            }
            className={classNames(
                styles.wrapper,
                input.hoverAnimation,
                decoded_styles.backgroundPanning
            )}
            // style={decodeStyle(parsedStyles.style, gs)}
            style={{
                // ...decodeStyle(parsedStyles.style, gs),
                ...decodeStyle(ps.fixStyle, gs),
                ...decoded_styles,
                ...(tablet(device) && decodeStyle(tabletStyle, gs)),
                ...(mobile(device) && decodeStyle(mobileStyle, gs)),
                // height: "100%",
                minHeight: "100%",
                display: "flex",
                alignItems: data.input.alignChilds,
                // backgroundColor: "#aa33ff33",
                backdropFilter: decoded_styles.backgroundFilter,
                backgroundSize: "cover",
                objectFit: "cover",
                backgroundRepeat: "no-repeat",
                cursor: input.action?.type === "none" ? "auto" : "pointer",
            }}
        >
            {/* <div className={styles.psudo}></div> */}
            {children}
        </div>
    );
}

export default ContainerWrapper;
